export enum AffiliateType {
  employer = 'Employer',
  healthSystem = 'Health System',
  healthPlan = 'Health Plan',
}

// Two different things in this codebase are called `care_model`, and they do
// not share values:
//
// - this one, on the affiliate, says which product that partner bought. The
//   backend stores it as a version string, "1.0" or "2.0".
// - `CareModel` in `api/types` is on the user, and says how that person is
//   actually being cared for: "Digital-only", "Coach-only" or "Collaborative".
//
// Comparing an affiliate against `CareModel.Collaborative` therefore never
// matches, and before this enum existed nothing stopped you writing it, because
// the field was typed as a plain string. The members are named after what the
// partner gets rather than after the version number, since "2.0" on its own
// says nothing at a call site.
export enum AffiliateCareModel {
  coachOnly = '1.0',
  collaborative = '2.0',
}

export type Affiliate = {
  affiliate_type: AffiliateType;
  care_model?: AffiliateCareModel;
  landing_page_banner: string;
  landing_page_middle_body?: string;
  landing_page_footer_body?: string;
  candid_eligibility?: boolean;
  cobranded_header?: boolean;
  covers_ayble?: boolean;
  discount?: number;
  discount_code?: string;
  faq_link?: string;
  group_id_required?: boolean;
  landing_page_top_header: string;
  logo: string;
  name: string;
  required_referrer: any;
  landing_page_top_body: string;
  utm_source: string;
  cost_transparency_header: string | null;
  cost_transparency_body: string | null;
  is_saml: boolean;
};

export type AffiliateLookup = {
  name: string;
  utm_source: string;
  required_referrer?: string;
  id: string;
};
